import type { GardenType } from '@ui/utils/garden';
import type { ReactNode } from 'react';
import React, { useContext } from 'react';

type GrowHelpersContextValue = {
  gardenType: GardenType;
};

const GrowHelpersContext = React.createContext<GrowHelpersContextValue>({
  gardenType: 'VVS',
});

const GrowHelpersProvider = ({
  children,
  gardenType,
}: {
  children: ReactNode;
  gardenType: GardenType;
}) => {
  return (
    <GrowHelpersContext.Provider value={{ gardenType }}>
      {children}
    </GrowHelpersContext.Provider>
  );
};

export const useGrowHelpers = () => {
  const { gardenType } = useContext(GrowHelpersContext);
  return { gardenType };
};

export default GrowHelpersProvider;
